import { useIntl } from 'react-intl';

import ContourBackdrop from '../../ContourBackdrop/ContourBackdrop';

import { clsx } from 'clsx';

import { ChevronDown } from 'lucide-react';

import { faqs } from '../config';

import styles from './faq.module.css';

export function Faq() {
	const intl = useIntl();

	return (
		<section className={styles.section} aria-labelledby='faq-title'>
			<ContourBackdrop className={styles.contours} rings={7} from={3.4} />
			<div className={clsx('container', styles.wrapper)}>
				<header className={styles.header}>
					<h2 className={styles.title}>
						{intl.formatMessage({ id: 'ContactUsId14' })}
					</h2>
					<p className={styles.subtitle}>
						{intl.formatMessage({ id: 'ContactUsId13' })}
					</p>
				</header>

				<div className={styles.list}>
					{faqs.map(faq => (
						<details key={faq.id} name='faq' className={styles.item}>
							<summary className={styles.question}>
								<span>{intl.formatMessage({ id: faq.questionId })}</span>
								<ChevronDown aria-hidden='true' className={styles.icon} />
							</summary>
							<p className={styles.answer}>
								{intl.formatMessage({ id: faq.answerId })}
							</p>
						</details>
					))}
				</div>
			</div>
		</section>
	);
}
